<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">QR Assets Details</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onClick()">X</button>
    </div>
</div>
<!-- photos and videos button -->
<div>
    <div class="photos">
        <div class="photos_list">
            <button [ngClass]="{'photos_btn':selectedButton === 'photos','videos_btn':selectedButton !=='photos'}"
                (click)="selectButton('photos')">Photos</button>
            <button [ngClass]="{'photos_btn':selectedButton ==='videos','videos_btn':selectedButton !=='videos'}"
                (click)="selectButton('videos')">Videos</button>
        </div>
    </div>
</div>

<!-- photos Grid List -->

<div class="photos_item" *ngIf="selectedButton ==='photos'">
    <div class="photos_grid">
        <div class="image-container"  [ngClass]="{'highlighted': checked}"  (click)="toggleSelection()">
            <img class="computer" src="../../../../assets/image/thum_img.svg" alt="">
            <div class="checkmark" *ngIf="checked">&#10003;</div>
        </div>
     
           
        <img class="computer" src="../../../../assets/image/thum_img (1).svg" alt="">
        <img class="computer" src="../../../../assets/image/img_del.svg" alt="">
        <img class="computer" src="../../../../assets/image/img_del (1).svg" alt="">
        <img class="computer" src="../../../../assets/image/img_del (2).svg" alt="">
        <img class="computer" src="../../../../assets/image/thum_img (2).svg" alt="">
    </div>
</div>

<div class="videos_item" *ngIf="selectedButton ==='videos'">
    <div class="videos_grid">
        <img class="computer" src="../../../../assets/image/thum_img.svg" alt="">
        <img class="computer" src="../../../../assets/image/thum_img.svg" alt="">
        <!-- <img class="computer" src="../../../../assets/image/thum_img.svg" alt=""> -->
    </div>
</div>